@switch (theme().timerType) {
  @case(TimerType.nav) {
    <div class="idh-timer__content">
      @if (iconVisible()) {
        <idh-icon [name]="'fs-status'" [size]="'xs'" [variant]="timerState()"></idh-icon>
      }
      <span class="idh-timer__label">{{ seconds() | duration: false }}</span>
    </div>
  }

  @case (TimerType.toast) {
    <idh-timer-toast [seconds]="seconds()"></idh-timer-toast>
  }
}
